(function() {
  'use strict';

  angular
    .module('routeA11y', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
      'ngResource', 'ui.router', 'ui.bootstrap']);

})();

(function () {
  'use strict';

  angular
    .module('routeA11y')
    .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($rootScope) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element) {
      $rootScope.$on('$viewContentLoaded',
        function (event) {
          element[0].focus();
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('routeA11y')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {
      var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('routeA11y')
    .directive('calculator', calculator);

  /** @ngInject */
  function calculator() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/calculator/calculator.html',
      controller: CalculatorController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CalculatorController($timeout) {
      var vm = this;
      vm.calculate = calculate;

      function calculate() {
        vm.calculated = false;
        $timeout(function() {
          vm.calculated = true;
          vm.result = Math.floor((Math.random() * 10) + 1) + " + "  + Math.floor((Math.random() * 10) + 1);
        }, 1000);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('routeA11y')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('routeA11y')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('base', {
        abstract: true,
        views: {
          "nav": {
            templateUrl: 'app/components/header/header.html'
          },
          "main": {
            template: '<ui-view role="main"></ui-view>'
          },
          "footer": {
            templateUrl: 'app/components/footer/footer.html'
          }
        }
      })
      .state('base.index', {
        url: "/",
        templateUrl: 'app/states/home/home.html'
      })
      .state('base.liveAria', {
        url: "/route1",
        templateUrl: 'app/states/route1/route1.html'
      })
      .state('base.busyButton', {
        url: "/route2",
        templateUrl: 'app/states/route3/route2.html'
      })
      .state('base.loading', {
        url: "/loading",
        templateUrl: 'app/states/route3/route3.html'
      })
      .state('base.alert', {
        url: "/alert",
        templateUrl: 'app/states/route3/route3.html'
      })
      .state('base.errorfield', {
        url: "/errorfield",
        templateUrl: 'app/states/route3/route3.html'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('routeA11y');

})();

(function() {
  'use strict';

  angular
    .module('routeA11y')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

angular.module("routeA11y").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/calculator/calculator.html","<div class=\"calculator text-center\"><button ng-click=\"vm.calculate();\" aria-controls=\"calculate-result\">Calculate</button><div id=\"calculate-result\" role=\"region\" aria-live=\"assertive\" aria-relevant=\"all\"><div ng-if=\"vm.calculated\" class=\"result\"><span>Result:</span><span>{{ vm.result }}</span></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"row\" id=\"footer\" role=\"contentinfo\"><div class=\"col-sm-12 footer-content\"><div class=\"text-center\"><h5 class=\"row\"><span class=\"col-xs-12 col-sm-6\">Power by Julia Passynkova</span> <span><span class=\"glyphicon glyphicon-envelope\" aria-hidden=\"true\"></span> Email: <a href=\"mailto:ipassynk@hotmail.com\">ipassynk@hotmail.com</a></span></h5></div></div></div>");
$templateCache.put("app/components/header/header.html","<acme-navbar></acme-navbar>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\" role=\"navigation\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/ipassynk/route-a11y\"><span class=\"glyphicon glyphicon-home\"></span>A11Y Patterns</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\" role=\"menu\"><li><a ui-sref=\"base.index\" role=\"menuitem\">Routing</a></li><li><a ui-sref=\"base.liveAria\" role=\"menuitem\">Aria Live</a></li><li><a ui-sref=\"base.busyButton\" role=\"menuitem\">Busy Button</a></li><li><a ui-sref=\"base.loading\" role=\"menuitem\">Loading</a></li><li><a ui-sref=\"base.loading\" role=\"menuitem\">Alert</a></li><li><a ui-sref=\"base.loading\" role=\"menuitem\">Error Field</a></li><li><a ui-sref=\"base.loading\" role=\"menuitem\">Title</a></li></ul></div></div></nav>");
$templateCache.put("app/states/home/home.html","<div id=\"home\"><div class=\"well\"><h1>Routing</h1></div><p>This is my attempt to add accessibility to angular SPA application. Router UI is used to navigate between different application states. Therefore, the navigation and footer stays the same and only the main area gets updated.</p>When a user clicks on a navigation link that changes the state the goal is:<ul><li>To push the dynamic content to screen reader to be announced</li><li>Move focus should to the new dynamic content</li></ul><h3>Push dynamic content</h3>I tried to use <b>aria-live</b> but somehow it did not work for this case. Role <b>alert</b> made the magic: <img class=\"img-responsive rolealert\" src=\"assets/images/rolealert.png\" alt=\"code with role alert\"><h3>Focus management</h3><b>AutoFocus</b> directive was added to dynamically move the focus when on the success routing event.<h3>How to test</h3>I tested the solution using Voice Over on Mac, NVDA on Windows and ChromVox plugin. Here is screen log from Voice Over when I clicked on \'Route2\' navigation link. As you see the screen reader was able to announce the new dynamic content automatically. <img class=\"img-responsive\" src=\"assets/images/voiceover.png\" alt=\"voice over screen capture\"><h3>Suggestions</h3>Please let me know if you solved this problem using any other means.</div>");
$templateCache.put("app/states/route1/route1.html","<div id=\"result1\"><div class=\"well\"><h1 class=\"text-center\">Aria Live</h1></div><p>The page demonstrates live aria usage. Upon the button click a new region is opened and screen reader announced it.</p><div class=\"row\"><div class=\"col-sm-6\"><calculator></calculator></div><div class=\"col-sm-6 text-center\"><img class=\"img-responsive rolealert\" src=\"assets/images/livearia.png\" alt=\"screen log with live aria\"><div class=\"help-block\">Voice Over announced the result when calculate button is clicked</div></div></div></div>");
$templateCache.put("app/states/route2/route2.html","<div class=\"well\"><h1 class=\"text-center\">Route2</h1></div><p>Route2 content is here ....</p><label>Route2 name: <input name=\"route2\"></label>");
$templateCache.put("app/states/route3/route3.html","<h1>Need to add (TODO)</h1>");}]);